export class FittingRequestForm extends BX.Event.EventEmitter
{
    constructor(formNode) 
    {
        super();
        this.setEventNamespace('Mario.FittingRequest.Form');

        this.formNode = formNode;
        this.bindEvents();
    }

    bindEvents() 
    {
        if (!this.formNode) {
            return;
        }
        
        this.formNode.addEventListener('submit', e => this.onSubmit(e));
        [...this.formNode.elements].forEach(element => {
            if (!this.shouldValidate(element)) {
                return;
            }

            $(element).on('input', () => this.cleanValidation(element));
            $(element).on('change', () => this.cleanValidation(element));
        });
    }

    cleanValidation(input) 
    {
        input.setCustomValidity('');
        input.classList.remove('was-validated');
    }

    showInputError(input, msg)
    {
        input.setCustomValidity(msg);
        BX.Dom.replace(
            input.parentNode.querySelector('.invalid-feedback'),
            BX.Tag.render`<div class="invalid-feedback">${msg}</div>`, 
        );
    }

    validate() 
    {
        let result = true;

        [...this.formNode.elements].forEach(element => {
            if (!this.shouldValidate(element)) {
                return;
            }

            if (!element.checkValidity()) {
                this.showInputError(element, 'Введите корректный номер телефона');
                result = false;
            } else if (element.dataset.entity === 'phone-input') {
                if (!this.validatePhone(element)) {
                    this.showInputError(element, 'Введите корректный номер телефона');
                    result = false;
                }
            }

            element.classList.add('was-validated');
        });

        return result;
    }

    validatePhone(input)
    {
        const value = $(input).inputmask('unmaskedvalue');
        return /^[0-9]{10}$/.test(value);
    }

    shouldValidate(element)
    {
        if (!('checkValidity' in element) || element.type === 'hidden' || element.tagName === 'BUTTON') {
            return false;
        }

        return true;
    }

    async onSubmit(e) 
    {
        e.preventDefault();

        if (!this.validate()) {
            return;
        }

        const button = this.formNode.querySelector('button[type="submit"]');
        BX.Dom.addClass(button, 'btn__loading')

        try {
            await this.sendRequest();
            this.emit('success');
        } catch(e) {
            console.error(e);
        } finally {
            setTimeout(() => BX.Dom.removeClass(button, 'btn__loading'), 2000)
        }
    }

    sendRequest()
    {
        const phone = this.formNode.querySelector('[data-entity="phone-input"]')?.value;
        const data = JSON.parse(this.formNode.querySelector('[data-entity="products-data"]')?.value);
        const source = this.formNode.querySelector('[data-entity="source"]')?.value;;

        return new Promise((resolve, reject) => {
            $.post(`/ajax/product/fitting_request/`, { phone, data, source }, null, 'json')
            .then(() => resolve()).catch(reject);
        });
    }
}

export class FittingRequestPopup 
{
    static get DEFAULT_OPTIONS() 
    {
        return {
            mobileBreakpoint: 991,
            showAfter: 0,
            ymPrefix: '',
            expandDelay: 300
        };
    }

    constructor(rootNode, options = {}) 
    {
        this.rootNode = rootNode;
        this.backdropNode = null;
        this.options = BX.Runtime.merge({}, FittingRequestPopup.DEFAULT_OPTIONS, options);
        
        const formNode = this.rootNode.querySelector('form');
        this.form = new FittingRequestForm(formNode);

        this.isOpen = false;
        this.expandTimeout = null;
        
        this.bindEvents();
        
        if (options.autoShow !== false) {
            setTimeout(() => this.showPopup(), this.options.showAfter);
        }
    }

    bindEvents() 
    {
        this.rootNode.querySelector('[data-entity="close"]')?.addEventListener('click', () => {
            this.closePopup();
        });

        // if (!this.isMobile()) {
        //     this.rootNode.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        //     this.rootNode.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
        // }

        BX.Event.EventEmitter.subscribe('Mario:FittingRequestModal:shown', () => {
            this.closePopup();
        });

        BX.Event.EventEmitter.subscribe('Mario:CardV2:add2basket_popup_shown', () => {
            this.closePopup();
        });

        this.form.subscribe('success', () => this.onSuccess());
    }
    
    handleMouseEnter()
    {
        clearTimeout(this.expandTimeout);
        this.expandTimeout = setTimeout(() => {
            this.expand();
        }, this.options.expandDelay);
    }

    handleMouseLeave()
    {
        clearTimeout(this.expandTimeout);
        this.collapse();
    }
    
    expand()
    {
        if (this.rootNode.classList.contains('card-fitting--expanded')) {
            return;
        }
        
        BX.Dom.removeClass(this.rootNode, 'card-fitting--collapsed');
        BX.Dom.addClass(this.rootNode, 'card-fitting--expanded');

        this.reachGoal('fr_expand');
    }

    collapse()
    {
        if (this.rootNode.classList.contains('card-fitting--collapsed')) {
            return;
        }

        BX.Dom.removeClass(this.rootNode, 'card-fitting--expanded');
        BX.Dom.addClass(this.rootNode, 'card-fitting--collapsed');

        this.reachGoal('fr_collapse');
    }

    onSuccess()
    {
        BX.Dom.replace(
            this.rootNode.querySelector('[data-entity="body"]'),
            BX.Tag.render`
                <div class="cart-fitting__body" data-entity="body">
                    <div class="card-fitting__success">Менеджер уже Вам звонит</div>
                </div>
            `
        );

        this.rootNode.style.height = 'auto'

        this.expand();
        setTimeout(() => this.closePopup(), 3000);
        this.reachGoal('fr_success');
    }

    showPopup() 
    {
        if (document.querySelector('#fitting-modal')) {
            return;
        }

        const rootNode = this.rootNode;

        const handleAnimationEnd = function() {
            BX.Dom.removeClass(rootNode, 'animate fadeInBottom30');
            rootNode.removeEventListener('animationend', handleAnimationEnd);
        };
        rootNode.addEventListener('animationend', handleAnimationEnd);

        BX.Dom.removeClass(rootNode, 'hidden');
        BX.Dom.addClass(rootNode, 'animate fadeInBottom30');

        if (this.isMobile()) {
            this.expand();
            if (!this.backdropNode) {
                this.backdropNode = BX.Tag.render`<div class="card-fitting-backdrop"></div>`;
                BX.Dom.append(this.backdropNode, document.body);
                this.backdropNode.addEventListener('click', () => this.closePopup());
            }
        }

        this.isOpen = true;
        this.reachGoal('fr_show');
        BX.Event.EventEmitter.emit('Mario:FittingRequestPopup:shown');
    }

    closePopup() 
    {
        if (!this.isOpen) {
            return;
        }
        
        const rootNode = this.rootNode;
        clearTimeout(this.expandTimeout);

        const handleAnimationEnd = function() {
            BX.Dom.removeClass(rootNode, 'animate fadeOutTop30');
            rootNode.removeEventListener('animationend', handleAnimationEnd);
            BX.Dom.addClass(rootNode, 'hidden');
        };
        rootNode.addEventListener('animationend', handleAnimationEnd);

        BX.Dom.addClass(rootNode, 'animate fadeOutTop30');

        if (this.backdropNode) {
            const handleBackdropTransitionEnd = () => {
                this.backdropNode.removeEventListener('transitionend', handleBackdropTransitionEnd);
                this.backdropNode.remove();
                this.backdropNode = null;
            };
            
            this.backdropNode.addEventListener('transitionend', handleBackdropTransitionEnd);
            this.backdropNode.style.opacity = 0;
        }
        
        this.isOpen = false;
        this.reachGoal('fr_hide');
    }

    isMobile() 
    {
        return window.matchMedia(`(max-width: ${this.options.mobileBreakpoint}px)`).matches;
    }

    reachGoal(name)
    {
        if ('ym' in window) {
            ym(window._store?.state?.ym_id, 'reachGoal', `${(this.options.ymPrefix || '')}${name}`);
        }
    }
}

export class FittingRequestModal
{
    static get DEFAULT_OPTIONS() 
    {
        return {
            ymPrefix: '',
        };
    }

    constructor(rootNode, options = {}) 
    {
        this.rootNode = rootNode;
        this.options = BX.Runtime.merge({}, FittingRequestPopup.DEFAULT_OPTIONS, options);
        
        this.formNode = this.rootNode.querySelector('form');
        this.form = new FittingRequestForm(this.formNode);

        $(this.formNode).find('.js-phone').inputmask('+7 (999) 999-99-99');
        
        this.init();
        this.bindEvents();
    }

    init()
    {
        this.reachGoal('fr_modal_init');
        BX.Event.EventEmitter.emit('Mario:FittingRequestModal:shown');
        
        window.rebindBasketItemButtons();
        this.fillProductsData();
    }

    fillProductsData()
    {
        const productsData = [];
        window._store.state.basket.addedIds.forEach(id => {
            const itemNode =  this.rootNode.querySelector(`.js-basket_item[data-id="${id}"]`);

            if (itemNode) {
                productsData.push({ id: itemNode.dataset.id, name: itemNode.dataset.name })
            }
        });

        const productsDataInput = this.formNode.querySelector('[data-entity="products-data"]');
        productsDataInput.value = JSON.stringify(productsData)
    }

    bindEvents() 
    {
        window._store.subscribe(window._EventTypes.BASKET_UPDATED, () => this.fillProductsData());
        this.form.subscribe('success', () => this.onSuccess());

        $(this.rootNode).on('hidden.bs.modal', () => {
            $(this.rootNode).remove();
        });
    }

    onSuccess()
    {
        BX.Dom.replace(
            this.rootNode.querySelector('[data-entity="content"]'),
            BX.Tag.render`
                <div class="fitting-modal__success" data-entity="content">
                    <div class="fitting-modal__success-icon">
                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_401_3565)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M41.9869 19.5564C41.9869 19.5564 28.7531 42.6187 28.5244 42.8249C27.7687 43.5374 26.5819 43.5001 25.875 42.7501L17.3025 34.8374C16.5937 34.0874 16.6331 32.8876 17.3888 32.1938C18.1444 31.4813 19.3313 31.5187 20.04 32.2687L26.7487 38.4563L38.7394 17.6814C39.2569 16.8001 40.4025 16.4811 41.3006 17.0061C42.1969 17.5124 42.5044 18.6751 41.9869 19.5564ZM30 0C13.4325 0 0 13.425 0 30C0 46.575 13.4325 60 30 60C46.5675 60 60 46.575 60 30C60 13.425 46.5675 0 30 0Z" fill="#27AE60"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_401_3565">
                                    <rect width="60" height="60" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="fitting-modal__success-content">
                        <div class="fitting-modal__success-title">Спасибо за заявку!</div>
                        <div class="fitting-modal__success-text">Менеджер уже связывается с Вами.</div>
                    </div>
                </div>
            `
        );

        this.reachGoal('fr_modal_success');
    }

    reachGoal(name)
    {
        if ('ym' in window) {
            ym(window._store?.state?.ym_id, 'reachGoal', `${(this.options.ymPrefix || '')}${name}`);
        }
    }
}